import { Box, Text } from "@mantine/core";

interface RegulatoryDutyDetailRowProps {
  title?: string;
  children?: React.ReactNode;
}

function RegulatoryDutyDetailRow({
  title,
  children
}: RegulatoryDutyDetailRowProps) {
  if (!children) {
    return null;
  }

  return (
    <Box className="RegulatoryDutyDetailRow" mb="xs">
      {title && <Text>{title}</Text>}
      {children}
    </Box>
  );
}

export { RegulatoryDutyDetailRow };
